import { useCurrentGroup } from "hooks/useCurrentGroup";
import { useChatFilterPicks } from "hooks/useChatFilterPicks";
import { useGetFilteredChannelIdsQuery } from "store/apis/chat";

type FilteredChannelIds = {
  channelIds: string[] | null;
  isResolving: boolean;
  hasFailed: boolean;
};

export const useFilteredChannelIds = (
  isArchivedTab = false
): FilteredChannelIds => {
  const { uuid: groupId } = useCurrentGroup();
  const { entityIds, seasons } = useChatFilterPicks();

  const hasPicks = Boolean(entityIds || seasons);
  const hasEmptyPick = entityIds?.length === 0 || seasons?.length === 0;

  const { data, isFetching, isError } = useGetFilteredChannelIdsQuery(
    {
      groupId: groupId!,
      entityIds: entityIds || undefined,
      seasons: seasons || undefined,
      frozen: isArchivedTab,
    },
    { skip: !groupId || !hasPicks || hasEmptyPick }
  );

  if (hasEmptyPick) {
    return { channelIds: [], isResolving: false, hasFailed: false };
  }

  if (!hasPicks) {
    return { channelIds: null, isResolving: false, hasFailed: false };
  }

  return {
    channelIds: data?.channel_ids || null,
    isResolving: isFetching && !isError,
    hasFailed: isError,
  };
};
